<template lang="html">
  <div class="" id="vergelijk">

      <div class="banner">
        <div class="top-header" style="height:125px;background:#f0f8ff;background:#2ecc7114 !important;">
          <i class="mdi mdi-car-hatchback driving-car" ></i>
          <i class="mdi mdi-tree front-tree"></i>
          <i class="mdi mdi-tree back-tree"></i>

          <Shape class="position-absolute shape bottom-1"/>
        </div>
      </div>


      <!-- INTRO -->
      <div class="features pb-30 ">
        <div class="container">
          <div class="row">
            <div class="col-md-12 intro">
              <h4 v-scroll-to="'#whatthelike'" class="mouseover">Autokosten</h4>
              <h1 itemprop="name">TCO Vergelijker</h1>

              <div class="row">
                <div class="col-md-6">
                  <p>
                    WhatTheRange rekent graag de autokosten voor je uit. Maak een eigen keuze op basis van <b>looptijd</b> en <b>kilometrage</b> wat voor jou van toepassing is om een volledig overzicht van alle vaste en variabele <b>kosten per maand</b> te bekijken.
                    </p>

                    <p>
                      Hieronder vind je drie alternatieven op basis van de gekozen elektrische <b>{{compared['compaire_car_choosen'][0].cMerknaam}} {{compared['compaire_car_choosen'][0].cModelnaam}}</b>, het alternatief bestaat uit elektrisch en benzine.
                      Wil je meer informatie over hoe deze alternatieven zijn opgebouwd? <u class="mouseover text-colored" v-scroll-to="'#calculate'">Klik dan hier</u>.
                    </p>
                </div>
                <div class="col-md-6 text-center mobile-margin-top">
                  <div class="row">
                    <div class="col-6">
                      <label for=""><b>Wijzig looptijd</b> </label>
                      <v-select
                        class="style-chooser mt-2"
                        v-model="looptijd"
                        placeholder="Kies een looptijd"
                        @input="getTCO()"
                        :options="looptijdList"
                      />
                    </div>
                    <div class="col-6">
                      <label for=""><b>Wijzig kilometrage</b></label>
                      <v-select
                        class="style-chooser mt-2"
                        v-model="kilometrage"
                        placeholder="Kies een kilometrage"
                        @input="getTCO()"
                        :options="kilometrageList"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- END INTRO -->

      <div class="model-list" id="whatthelike">
        <div class="container">
          <div class="row max-w-10">

            <div v-swiper:mySwiper="swiperOption" style="    margin: 0;    width: 100%;padding-right: 30px;padding-bottom: 30px;">

            <div class="swiper-pagination" slot="pagination" style="top: 0;bottom: auto;"></div>

              <div class="swiper-wrapper">
                <div class="col-md-6 pt-6 col-xl-4 col-block text-center p-relative car-block swiper-slide" v-bind:key="`compare-${index}${Math.floor(Math.random() * 10000) + 1}`" v-for="(car, index) in compared">

                  <div class="">
                    <h5 class="pb-5 text-center" v-if="index == 'compaire_car_choosen'">
                      <div class="top-line"></div>
                      <div class="top-line-double"></div>
                      De gekozen EV auto
                    </h5>
                    <h5 class="pb-5 text-center" v-if="index == 'compaire_car_alt_e'">
                      EV alternatief
                    </h5>
                    <h5 class="pb-5 text-center" v-if="index == 'compaire_car_alt_b'">
                      <div class=""></div>
                      Benzine alternatief
                    </h5>

                  </div>

                  <div class="col-block text-center p-relative car-block" v-if="car != null && car.length != 0 && car[0] != null">
                   <div class="ad-logo ad-logo--swiper">
                      <div class="outer-spin">
                        <div class="outer-arc outer-arc_start-a"></div>
                        <div class="outer-arc outer-arc_end-a"></div>
                        <div class="outer-arc outer-arc_start-b"></div>
                        <div class="outer-arc outer-arc_end-b"></div>
                        <div class="outer-moon-a"></div>
                        <div class="outer-moon-b"></div>
                      </div>
                    </div>
                   <div itemscope="itemscope" itemtype="https://schema.org/Car" class="vergelijk future">
                     <div class="badge-verwacht" >
                       <span v-if="car[0].cBrandstof == 'd'">Diesel</span>
                       <span v-else-if="car[0].cBrandstof == 'l'">Benzine</span>
                       <span v-else-if="car[0].cBrandstof == 'lh'">Benzine (Hybride)</span>
                       <span v-else-if="car[0].cBrandstof == 'dh'">Diesel (Hybride)</span>
                       <span v-else-if="car[0].cBrandstof == 'Electrisch 100%'">Elektrisch</span>
                       <span v-else>{{car[0].cBrandstof}}</span>
                     </div>
                      <span itemprop="sku" class="d-none">{{car[0].nModelID}}</span>
                      <div class="pattern bg-white position-relative">
                        <img :src="'https://media.autodisk.nl/fotos/geel/'+car[0].nModelID+'/16-9/900/a.jpg'" onerror="this.src='/banner.png';" :alt="car[0].cMerknaam+' '+car[0].cModelnaam" class="car" itemprop="image" >
                        <Shape class="position-absolute shape left-0"/>
                      </div>
                      <div class="main-info" style="min-height: 145px;">
                        <h2 class="text-colored mt-15 f22" itemprop="name" style="">
                          <span itemprop="brand">{{car[0].cMerknaam}}</span>
                          {{car[0].cModelnaam}}
                        </h2>
                        <p itemprop="description">
                          {{car[0].cuitvoering1}}
                          {{car[0].cuitvoering2}}<br>
                        </p>
                        <div class="" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                          <p class="p-0 price">
                            <b><span itemprop="priceCurrency" content="EUR">&euro;</span> <span itemprop="price">{{carPrice(car[0].nConsumentenprijs)}}</span>,-</b>
                          </p>
                        </div>
                        <div v-if="car[0].TCO != null && !loaderTCO && car[0].TCO.TCO_Uitkomst[0].TCO_Valid == 'True'" class="mx-4 d-flex justify-content-center flex-wrap">
                          <span v-key="`badge-${Math.floor(Math.random() * 10000) + 1}`" class="badge badge-pill badge-vergelijking" :class="`badge-vergelijking--${badge.type}`" v-for="badge, i in getBadges(index)">
                            <i class="mdi" :class="`mdi-${badge.icon}`"></i><span class="badge__text">{{badge.value}} {{badge.message}}</span>
                          </span>
                        </div>
                      </div>

                      <ul v-if="car[0].TCO != null && !loaderTCO && car[0].TCO.TCO_Uitkomst[0].TCO_Valid == 'True'" class="tco-costs">
                        <li>
                          <span>{{looptijd}} Mnd / {{Math.round(kilometrage / 12)}} Km</span>
                          <span class="float-right">Per maand</span>
                        </li>
                        <li class="bg-color-green total-block">
                          <span style="font-weight: 600;">Totaal</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                        <li style="    padding-top: 15px;">
                          <span>Afschrijving en Rente</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].AfschrijvingEnRente))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                        <li>
                          <span>Wegenbelasting</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].MRB))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                        <li>
                          <span>Verzekering WA Casco</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].Verzekering))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                        <li>
                          <span>Reparatie en Onderhoud</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].ReparatieEnOnderhoud))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                        <li>
                          <span>Banden</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].Banden))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                        <li>
                          <span>Brandstof</span>
                          <span class="float-right"><b>&euro; {{ String(Math.round(parseFloat(car[0].TCO.TCO_Uitkomst[0].Brandstof))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                      </ul>

                      <ul  class="tco-costs">
                        <li>
                          <span>CO<sub>2</sub>
                            <i class="mdi mdi-tree text-colored co2-tree" v-if="car[0].nCo2 == 0 || car[0].nCo2 == null "></i>
                          </span>
                          <span class="float-right"><b v-if="Math.round(parseFloat( car[0].nCo2 )) > 0">{{ String(Math.round(parseFloat( car[0].nCo2 ))).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} g/km</b><b v-else>0 g/km</b></span>
                        </li>
                        <hr>
                        <li>
                          <span class="">Netto bijtelling <div @click="showNettoBijtelling = index" class="netto-bijtelling__icon"><i class="mdi mdi-settings"></i></div></span>
                          <span class="float-right" v-if="!priveKostenLoading && meerDan500km"><b>&euro; {{ String(Math.round(parseFloat(car[0].nettoKostenMaand)+parseFloat(eigenBijdrage ? eigenBijdrage : 0))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                          <span class="float-right" v-if="!priveKostenLoading && !meerDan500km"><b>&euro; {{ String(Math.round(0+parseFloat(eigenBijdrage ? eigenBijdrage : 0))).replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},-</b></span>
                        </li>
                      </ul>


                      <div class="spinner" v-if="loaderTCO">
                        <div class="dot1"></div>
                        <div class="dot2"></div>
                      </div>

                      <p v-if="car[0].TCO != null && !loaderTCO && car[0].TCO.TCO_Uitkomst[0].TCO_Valid == 'False'">Geen berekening gevonden</p>

                      <div class="row" v-if="index == 'compaire_car_alt_e' || index == 'compaire_car_choosen'">
                        <div class="col-md-12 ">
                          <nuxt-link :to="getRouteCarTCO(car[0], 'vergelijk/autokosten')" @click.native="reportEvent(index, 'tco', car[0])" class="specs secondary" v-if="index != 'compaire_car_choosen'">Autokosten</nuxt-link>
                          <nuxt-link :to="getRoute(car[0], 'elektrische-auto')" @click.native="reportEvent(index, 'specs', car[0])" class="specs" itemprop="url">Specificaties</nuxt-link>
                        </div>
                      </div>

                      <div class="row" v-if="index == 'compaire_car_alt_b' ">
                        <div class="col-md-12">
                          <p class="specs" itemprop="url" @click="isActive = true">Kies een andere auto</p>
                        </div>
                      </div>
                      <div class="alternative" style="background:#effbf4 !important;" :class="isActive?'':'active'" v-if="index == 'compaire_car_alt_b' ">
                        <div class="col-md-12" style="padding-top:60%;">
                          <input type="checkbox" name="segment" id="segment" value="" v-model="bSegment">
                          <label for="segment"><p class="p-0">Merken op basis van segment</p></label>
                        </div>
                        <div class="col-md-12 mt-3" >
                          <label for="segment"><b>Kies een merk</b></label>
                          <select v-model="sbrand" @change="getModels()">
                            <option value="" v-for="l in brands" v-bind:value="l">{{l.cMerknaam}}</option>
                          </select>
                        </div>
                        <div class="col-md-12 mt-3" v-if="models != null">
                          <label for="segment"><b>Kies een model</b></label>
                          <select v-model="sModel" @change="getTypes()" >
                            <option value="" v-for="l in models" v-bind:value="l">{{l.cModelnaam}} ({{l.nDeuren}}-deurs)</option>
                          </select>
                        </div>
                        <div class="col-md-12 mt-3" v-if="types != null">
                          <label for="segment"><b>Kies een uitvoering</b></label>
                          <select  v-model="sType">
                            <option value="" v-for="l in types" v-bind:value="l">{{l.cTypenaam_1}} {{l.cTypenaam_2}} </option>
                          </select>

                        </div>
                        <div class="col-md-12 mt-5">
                          <p @click="isActive = false" class="specs secondary">Sluiten</p>
                          <p @click="getCarByTypeId()" class="specs">Kiezen</p>
                        </div>
                      </div>
                      <div class="alternative" style="background:#effbf4 !important;" :class="(showNettoBijtelling == index) ? '' :'active'">
                        <div class="col-12 d-flex justify-content-center align-items-center" style="padding-top: 60%;">
                          <div class="col-12 mt-3 d-flex justify-content-between align-items-center">
                            <b>Rijdt u meer dan 500 kilometer privé?</b>
                            <div class="wtr__switch">
                              <div class="wtr__switch__left" @click="toggleShowNettoBijtellingOptions(true)" :class="(meerDan500km === true) ? 'wtr__switch--active':''"><b>Ja</b></div>
                              <div class="wtr__switch__right" @click="toggleShowNettoBijtellingOptions(false)" :class="(meerDan500km === false) ? 'wtr__switch--active':''"><b>Nee</b></div>
                            </div>
                          </div>
                        </div>
                        <transition name="slide-fade">
                          <netto-bijtelling-options :setEigenBijdrage="(nEB)=>{eigenBijdrage = nEB;}" :nEigenBijdrage="eigenBijdrage" :setBelastingsPercentage="(nBP)=>{belastingsPercentage = nBP;}" :nBelastingsPercentage="belastingsPercentage" />
                        </transition>
                      <div>

                        <div class="col-12 mt-4">
                          <p @click="showNettoBijtelling = undefined" class="specs secondary">Sluiten</p>
                          <p @click="getPriveKosten();showNettoBijtelling = undefined" class="specs">Bereken</p>
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
                 <div class="col-block text-center p-relative car-block " v-else  style="height:92%;">
                   <div class="vergelijk future bg-color-green" style="border-radius:8px;">
                     <div class="badge-verwacht" >
                       <span v-if="index == 'compaire_car_alt_b'">Benzine</span>
                       <span v-if="index == 'compaire_car_alt_e'">Elektrisch 100%</span>
                     </div>

                     <i class="mdi mdi-car-side" style="    display: block;    font-size: 54px;    padding-top: 60%;"></i>

                     <p class="text-colored mt-15 f22" style="    font-weight: 600;line-height: 1.4; font-family: 'Poppins', sans-serif;">
                       <span>WhatTheSorry</span>
                     </p>
                     <p style="white-space: normal !important;">
                       Er kon geen alternatief gevonden worden. Kies een andere auto om een complete vergelijking te krijgen.
                     </p>
                   </div>
                 </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      <!-- END Block -->

      <div id="calculate" class="features detail-intro">
        <div class="container">
          <div class="row">
            <div class="col-md-12 intro">

              <h4 v-scroll-to="'#vergelijk'" class="mouseover">TCO Vergelijker</h4>
              <h1 itemprop="name">Autokosten berekenen</h1>

              <p class="fact">Voor 1 ton CO2-uitstoot moeten 50 bomen een jaar lang groeien.</p>
              <div class="row">
                <div class="col-md-6">
                  <p>
                    Gelukkig kan <a href="https://www.autodisk.nl/" target="_blank">AutoDisk</a> voor iedere auto een uitstekende berekening maken van de te verwachten maandkosten. Dat geeft een nog veel beter beeld van het verschil in kosten tussen een elektrische auto en een auto met fossiele brandstof.
                    We hebben een aantal aannames gedaan om deze berekening te maken, maar dit geldt voor alle vergelijkingen. We rekenen met alle componenten die van belang zijn: Afschrijving, Rente, Verzekering, Reparatie, Onderhoud, Banden, Wegenbelasting en Brandstof.
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    Natuurlijk zijn het inschattingen naar de toekomst toe, maar die inschattingen zijn goed te noemen en worden gebruikt door ca. 200 Nederlandse leasemaatschappijen.
                    Voor de brandstofkosten van fossiele auto's maken we gebruik van TravelCard Praktijk verbruik en voor elektrisch verbruik rekenen we met onze WhatTheRange verbruik cijfers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import Banner from '@/components/Banner'
import CurrencyModule from '~/modules/currency'
import Shape          from '@/components/design/shape'
import vSelect from 'vue-select';
import NettoBijtellingOptions from '@/components/NettoBijtellingOptions'

export default {
  name:'vergelijk-autokosten',
  components:{
    Banner,
    Shape,
    vSelect,
    NettoBijtellingOptions
  },
  mixins:[CurrencyModule],

  async asyncData({ app, params, redirect  }) {
    return await app.$axios.$get('/api/vergelijking/'+params.carid+'/700/70').then((response) => {
      // define bcz overloaded data from web service
      let data = {
        compaire_car_choosen: response['compaire_car_choosen'],
        compaire_car_alt_e: response['compaire_car_alt_e'],
        compaire_car_alt_b: response['compaire_car_alt_b'],
      }
      return {
        compared : data,
      }
    }).catch(error => {
      return redirect('/vergelijk/autokosten')
    });
  },
  data(){
    return {
      showNettoBijtelling: undefined,
      meerDan500km: true,
      eigenBijdrage: 0,
      looptijd: 60,
      looptijdList: [12, 24, 36, 48, 60],
      kilometrage: 10000,
      kilometrageList: [10000, 15000, 20000, 25000, 30000, 35000, 40000],
      belastingsPercentage: 37.07,
      brands:null,
      models:null,
      types:null,
      isActive:false,
      sbrand:null,
      sModel:null,
      sType:null,
      bSegment:true,
      segment:'zz',
      swiperOption: {
            slidesPerView: 'auto',
            // spaceBetween: 0,
            loop: false,
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
          },
      // swiperOption: {
      //     slidesPerView: 'auto',

      //     centeredSlides: false,
      //     spaceBetween: 0,
      //     pagination: {
      //       el: '.swiper-pagination',
      //       clickable: true
      //     }
      //   },
      tcoLoaded: false,
      priveKostenLoading: true,
    }
  },

  head () {
    var model = this.compared.compaire_car_choosen[0];
    var seoModel = model.cMerknaam+'-'+model.cModelnaam.replace(/\s+/g, '-')+'-'+model.cuitvoering1.replace(/\s+/g, '-')+'-'+model.cuitvoering2.replace(/\s+/g, '-');
    var carName = model.cMerknaam+' '+model.cModelnaam.replace(/\s+/g, '-')+' '+model.cuitvoering1.replace(/\s+/g, ' ')

    return {
      title: `Bereken de autokosten van de ${carName} | WhatTheRange`,
      meta: [
        { hid: 'title', name: 'title', content: `Bereken de autokosten van de ${carName} | WhatTheRange` },
        { hid: 'og:title', property: 'og:title', content: `Bereken de autokosten van de ${carName} | WhatTheRange` },
        { hid: 'description', name: 'description', content: `Vergelijk en bereken de autokosten van de ${carName} op basis van Afschrijving, Rente, Verzekering, Reparatie, Onderhoud, Banden, Wegenbelasting en Brandstof met andere elektrische auto's.` },
        { hid: 'og:description', property: 'og:description', content: `Vergelijk en bereken de autokosten van de ${carName} op basis van Afschrijving, Rente, Verzekering, Reparatie, Onderhoud, Banden, Wegenbelasting en Brandstof met andere elektrische auto's.` },
        { hid: 'keywords', name: 'keywords', content: `Vergelijk, Autokosten, TCO, ${carName}, Afschrijving, Rente, Verzekering, Reparatie, Onderhoud, Banden, Wegenbelasting, Brandstof, WhatTheRange` },
        { hid: 'og:keywords', property: 'og:keywords', content: `Vergelijk, Autokosten, TCO, ${carName}, Afschrijving, Rente, Verzekering, Reparatie, Onderhoud, Banden, Wegenbelasting, Brandstof, WhatTheRange` },
        { hid: 'og:url', property: 'og:url', content: `https://www.whattherange.com/vergelijk/autokosten/${model.nTypeIDHist}/${seoModel}` },
        { hid: 'og:image', property: 'og:image', content: `https://media.autodisk.nl/fotos/geel/${model.nModelID}/16-9/1200/a.jpg` },
        { hid: 'og:image:secure_url', property: 'og:image:secure_url', content: `https://media.autodisk.nl/fotos/geel/${model.nModelID}/16-9/1200/a.jpg` },
        { hid: 'og:image:width', property: 'og:image:width', content: `1200` },
        { hid: 'og:image:height', property: 'og:image:height', content: `675` },
        { hid: 'og:image:alt', property: 'og:image:alt', content: `Bereken de autokosten van de ${carName} | WhatTheRange` },
        { hid: 'url', name: 'url', content: `https://www.whattherange.com/vergelijk/autokosten/${model.nTypeIDHist}/${seoModel}` },
        ]
    }
  },
  mounted(){
    this.$gtag('event', 'screen_view', {
        'app_name': 'whattherange',
        'screen_name' : 'Autokosten',
      });
    this.$gtag('event', `mounted`, {
        event_category: 'Autokosten',
        event_label: this.$route.params.cars,
        value: this.$route.params.carid,
    });
  },
  created(){
    this.getTCO();
    this.getBrands();
    this.getPriveKosten();
  },
  watch:{
    'bSegment': function(){
      this.getBrands();
    },
  },
  methods:{
    //
    toggleShowNettoBijtelling(index){
      this.showNettoBijtelling = index;
    },
    toggleShowNettoBijtellingOptions(status){
      this.meerDan500km = status;
      // this.eigenBijdrage = 0;
      // this.belastingsPercentage = {
      //   label:'37,10% (Belastbaar  tot € 68.507,-)',
      //   percentageLabel: '37,10%',
      //   percentage: 37.1
      // };
    },
    reportEvent(button, type, data) {
      this.$gtag('event', `clicked-on-${button}-${type}`, {
        event_category: 'Autokosten',
        event_label: data.nTypeId,
      });
    },
    getFormattedPrice(price){
      return String(Math.round(parseFloat(price))).replace(/\B(?=(\d{3})+(?!\d))/g, "")
    },
    getBadges(index){
      if(index === 'compaire_car_choosen'){
        return []
      }
      let badgeArray = [];
      let chosenCar = this.compared['compaire_car_choosen'];
      let comparedCar = this.compared[index];
      if(chosenCar[0].TCO.TCO_Uitkomst[0].TCO_Valid != 'True'){
        return []
      }
      if(parseInt(this.getFormattedPrice(chosenCar[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof)) >  parseInt(this.getFormattedPrice(comparedCar[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof))){
        badgeArray.push({
          type: "success",
          icon: "plus",
          value: `€ ${(this.getFormattedPrice(chosenCar[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof) - this.getFormattedPrice(comparedCar[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
          message: "goedkoper p/m",
        })
      }else{
        badgeArray.push({
          type: "danger",
          icon: "minus",
          value: `€ ${(this.getFormattedPrice(comparedCar[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof) - this.getFormattedPrice(chosenCar[0].TCO.TCO_Uitkomst[0].TCO_TotaalInBrandstof)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
          message: "duurder p/m",
        })
      }
      return badgeArray;
    },
    getTCO() {
      this.loaderTCO = true;
      var typeIdString = this.getComparedTypeId(this.compared)
      this.$axios.get('/api/Prijs/'+this.looptijd+'/'+this.kilometrage+'/'+typeIdString).then((response)=>{
        for(var tco in response.data){
            for(var index in this.compared)
                if(this.compared[index][0] != null && this.compared[index].length > 0)
                    if(response.data[tco].nTypeId == this.compared[index][0].nTypeIDHist)
                        this.compared[index][0].TCO = response.data[tco]
        }
        this.loaderTCO = false;
        this.tcoLoaded = true;
      });
    },
    getPriveKosten() {

      this.priveKostenLoading = true;
      // this.loaderTCO = true;
      let count = 0;
      Object.keys(this.compared).forEach(compareKey=>{
        const params = {
          nTypeID: this.compared[compareKey][0].nTypeID,
          nFiscaleWaarde: this.compared[compareKey][0].nConsumentenprijs,
          nBelastingPercentage: this.belastingsPercentage,
          nEigenBijdrage: this.eigenBijdrage,
        };
        // params.append('pnTypeId', this.compared[compareKey][0].nTypeID);
        // params.append('pnFiscaleWaarde', this.compared[compareKey][0].nConsumentenprijs);
        // params.append('pnBelastingsPercentage', this.belastingsPercentage);
        // params.append('pnEigenBijdrage', 0);
          // alert(params)
        this.$axios.post('/api/privekosten/', params).then((response)=>{
          count++;
          this.compared[compareKey][0].nettoKostenMaand = response.data.nNettoKostenMaand;
          if(count === Object.keys(this.compared).length){
              this.priveKostenLoading = false;
          }
          // this.loaderTCO = false;
          // this.tcoLoaded = true;
        });
      })

      // this.compared.forEach(car=>{
      //   console.log('ddd', car)
      // })

      return ;


      return this.compared[index][0].nettoKostenMaand
    },
    //
    getComparedTypeId(comparedList){
      var typeIds = '?'
      for(var index in comparedList)
          if(comparedList[index][0] != null && comparedList[index].length > 0)
              typeIds += ('&ntypeid='+comparedList[index][0].nTypeIDHist)
      return typeIds;
    },


    getBrands(){
      this.segment='zz'
      if(this.bSegment)
          this.segment = this.compared.compaire_car_choosen[0].cSegement
      this.$axios.get('/api/vergelijking/MMT/'+this.segment).then((response)=>{
        this.brands = response.data
      })
    },
    getModels(){
      this.$axios.get('/api/vergelijking/MMT/'+this.segment+'/'+this.sbrand.nMerkID).then((response)=>{
        this.models = response.data[0]['Modellen']
      })
    },
    getTypes(){
      this.$axios.get('/api/vergelijking/MMT/'+this.segment+'/'+this.sbrand.nMerkID+'/'+this.sModel.nModelID).then((response)=>{
        this.types = response.data[0]['Modellen'][0]['Types']
      })
    },

    getCarByTypeId(){
      this.$axios.get('/api/getType/'+this.sType.nTypeIDHist).then((response)=>{
        this.isActive = false
        // this.types = response.data['getUitvoeringenResult']
        this.compared.compaire_car_alt_b = response.data
        this.getTCO();
        this.getPriveKosten();
      })
    },


    getRoute(model, prefix){
      const seoModel = model.cMerknaam+'-'+model.cModelnaam.replace(/\s+/g, '-');
      const id = model.nModelID
      return '/'+prefix+'/'+id+'/'+seoModel;
    },
    getRouteCarTCO(model, prefix){
      const seoModel = model.cMerknaam+'-'+model.cModelnaam.replace(/\s+/g, '-')+'-'+model.cuitvoering1.replace(/\s+/g, '-')+'-'+model.cuitvoering2.replace(/\s+/g, '-');
      const id = model.nTypeIDHist
      return '/'+prefix+'/'+id+'/'+seoModel;
    },
    carPrice(price){
      return CurrencyModule.carPrice(price)
    },
  }
}
</script>

<style lang="scss">

  @import "../../../../node_modules/vue-select/src/scss/vue-select.scss";
  .netto-bijtelling__icon{
    display: inline;
    &:hover{
      cursor: pointer;
      i{
        color: #2ecc71;
      }
    }
  }
.wtr__switch{
  display: flex;
  width: 140px;
    background-color: white;
  .wtr__switch--active{
    background-color: #2ecc71;
    b{
      color: #FFF !important;
    }
  }
  .wtr__switch__left, .wtr__switch__right{
    width: 70px;
    border: 1px solid #2ecc71;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .wtr__switch__left{
    border-radius: 8px 0 0 8px;
    border-right: 0px solid #2ecc71 !important;
  }
  .wtr__switch__right{
    border-radius: 0 8px 8px 0;
    border-left: 1px solid #2ecc71 !important;
  }
  // .wtr__switch__right{
  //   width: 100px;
  //   height: 50px;
  // }
}
h5{
  color: #666 !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  // height:90px;
  padding-top:5px;
  background: #fff;
}
.top-line{
  width: 200px;
    height: 75px;
    z-index: -1;
    background: transparent;
    border: none;
    border-top: dashed 3px #2ecc71;
    border-radius: 50%;
    position: absolute;
    top: -17px;
    right: -100px;
    // right: -66px;
    opacity: 0.5;
}
.top-line-double{
  width: 550px;
  height: 129px;
  z-index: -1;
  background: transparent;
  border: none;
  border-top: dashed 3px #2ecc71;
  border-radius: 50%;
  position: absolute;
  top: -45px;
  right: -455px;
  // left: 250px;
  opacity: 0.5;
}

.co2-tree{
  font-size: 35px;
  position: absolute;
  margin-top: -18px;
  opacity: 0.5;
  right:90px;
}
.alternative{
  position: absolute;
  width: 100%;
      height: 100%;
 top: 0;
 overflow: hidden;
 background-color: #f0f8ff;
 color: #FFF;
 transition: all 500ms;
}

.fact{
   padding-top: 0;
   color: #b1b1b1 !important;
   line-height: 16px;
    margin-bottom: 1rem;
}
.alternative.active {
  top: 100%;
  height: 0;
}

.total-block{
  padding: 15px 30px;

  span{
    font-size: 18px;
  }
}
#vergelijk{
  ul{
    list-style-type: none;
    padding: 0;
    li{
      color:#232323 !important;
      font-family: 'Poppins', sans-serif;

      // font-weight: 600;
    }
    span{
      color: #666 !important;
      font-family: 'Poppins', sans-serif;

      // font-weight: 600;
    }
  }

  ul.tco-costs{
    li{
      text-align:left;
      padding: 10px 30px;
    }
  }

  .highlighted::after{
    content: 'Elektrisch';
    display: inline-block;
    position: absolute;
    right: -50px;
    top: 20px;
    background-color: #2ecc71;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    color: white;
    line-height: 40px;
    width: 200px;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .vergelijk{
    background: #fff;
    border-radius: 8px;
    padding-bottom: 10px;
    margin-bottom: 0px;
    height:100%;
    .pattern{
      border-radius: 8px;
    }
    a{
      padding: 10px 20px;
      background: #2ecc71;
      margin-right: 10px;
      border-radius: 30px;
      color: #fff !important;
      text-decoration: none;
      font-weight: 600;
      font-family: 'Poppins', sans-serif;

      border: 2px solid #2ecc71;
    }
  }
  p.desc{
    font-family: 'Poppins', sans-serif;


    font-weight: 600;
    position: relative;
    z-index: 999;
    max-width: 850px;
    margin: 0 auto;
  }

  h3{
    font-size: 14px;
    padding-bottom: 20px;
    color:#666 !important;
    font-weight: 600;
  }

  a.secondary, p.secondary{
    background: #fff !important;
    color:#2ecc71 !important;
    border: 2px solid #2ecc71;
  }

  .paddle{
    padding: 10px 20px;
    background: #2ecc71;
    margin-right: 10px;
    border-radius: 30px;
    color: #fff !important;
    text-decoration: none;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;

    border: 2px solid #2ecc71;
    background: #fff !important;
    color:#2ecc71 !important;
    border: 2px solid #2ecc71;
    outline: none !important;
  }

  /* The heart of the matter */
  /* The heart of the matter */
  .testimonial-group {
    overflow-x: auto !important;
    white-space: nowrap !important;
    // flex-wrap: nowrap;
  }
  //  .col-block{
  //   // display: inline-block;
  //   // float: none;
  // }
  .swiper-pagination-bullet-active{
    background: #2ecc71;
  }


}
  .vs__dropdown-toggle {
  border-radius: 30px;
}
  .vs__dropdown-menu {
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  /*border: 1px solid #f1f1f1;*/
    border: none;
    box-shadow: 0 0 0 1px transparent, 0 0 0 1px #f1f1f1 !important;
  border-top: 0;
  box-shadow: none;
  }
  .vs__dropdown-option--highlight{
      background-color: #2ecc71 !important;
    }
  .style-chooser {
  &.vs--open {
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  box-shadow: inherit;
  border: 1px solid #f1f1f1;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  max-width: 225px;
.vs__open-indicator{
  display:none;
}
    .vs__dropdown-toggle{
  border: 0;
  padding-left: 20px;
  width: 100%;
  min-height: 60px;
  color: #232323;
  outline: none;
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;

  font-size: 14px;
  z-index: 99999;
  background:#fff;
    }
  }
  .vs__clear{
    display: none;
  }
</style>


<style scoped>
.swiper-container{
  padding-top:50px !important;
}
</style>
